<style scope>
.w-e-text-container {
  height: 600px !important;
}
</style>
<template>
  <div>
    <Form :model="formData" ref="goodsFormData" :rules="rules" :labelWidth="120">
      <Tabs type="card" size="small" :animated="false">
        <TabPane icon="md-grid" label="基本信息">
          <Row>
            <Col span="12">
              <FormItem label="商品名称" prop="goods_name">
                <Input v-model="formData.goods_name" :maxlength="120" />
              </FormItem>
              <Row>
                <Col span="12">
                  <FormItem label="商品类别" prop="typeid">
                    <Select v-model="formData.typeid" @on-change="fn_load_typeattrlsit">
                      <Option
                        :value="item.id"
                        :label="item.type_name"
                        v-for="(item, index) in typeList"
                        :key="index"
                      ></Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col span="12">
                  <FormItem label="商品目录" prop="categoryid">
                    <Treeselect
                      transfer
                      v-model="formData.categoryid"
                      :multiple="false"
                      :options="categoryTree"
                    />
                  </FormItem>
                </Col>
              </Row>

              <Row>
                <Col span="12" v-if="formData.original_img">
                  <FormItem label="商品图片">
                    <Upload
                      name="filename"
                      :show-upload-list="false"
                      :action="uploadhost"
                      :format="['jpg', 'jpeg', 'png']"
                      :on-success="fn_uploadSuccess"
                      :max-size="2048"
                      :on-format-error="handleFormatError"
                      :on-exceeded-size="handleMaxSize"
                      style="display: inline-block;width:90px;"
                    >
                      <Button icon="ios-cloud-upload-outline">上传图片</Button>
                    </Upload>
                  </FormItem>
                </Col>
                <Col span="12" v-if="formData.original_img">
                  <FormItem label="商品图">
                    <img :src="logourl + formData.original_img" style="max-height:100px" />
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="12" v-if="formData.original_img">
                  <FormItem label="缩略图">
                    <!-- <cropper :src="goodsImageSrc" crop-button-text="确认提交" @on-crop="handleCroped"></cropper> -->
                    <Upload
                      name="filename"
                      :show-upload-list="false"
                      :action="uploadhost"
                      :format="['jpg', 'jpeg', 'png']"
                      :on-success="fn_simpleUploadSuccess"
                      :max-size="256"
                      :on-format-error="handleFormatError"
                      :on-exceeded-size="handleMaxSize"
                      style="display: inline-block;width:90px;"
                    >
                      <Button icon="ios-cloud-upload-outline">上传图片</Button>
                    </Upload>
                  </FormItem>
                </Col>
                <Col span="12" v-if="formData.goods_thumb">
                  <FormItem label="缩略图">
                    <img :src="logourl + formData.goods_thumb" style="max-height:100px" />
                  </FormItem>
                </Col>
              </Row>
              <FormItem label="商品主要描述" prop="goods_brief">
                <Input type="textarea" :rows="4" v-model="formData.goods_brief" :maxlength="255" />
              </FormItem>
              <FormItem label="商品备注" prop="remarks">
                <Input type="textarea" v-model="formData.remarks" :maxlength="255" />
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="商品货号" prop="goods_sn">
                <Input v-model="formData.goods_sn" :maxlength="60" placeholder="不填写货号,系统自动填充" />
              </FormItem>
              <FormItem label="品牌">
                <Select v-model="formData.brandid">
                  <Option
                    :value="item.id"
                    :label="item.brand_name"
                    v-for="(item, index) in brandList"
                    :key="index"
                  ></Option>
                </Select>
              </FormItem>
              <FormItem label="商品关键字" prop="keywords">
                <Input v-model="formData.keywords" :maxlength="255" />
              </FormItem>

              <FormItem label="推荐">
                <Checkbox v-model="formData.is_best" :value="1">精品</Checkbox>
                <Checkbox v-model="formData.is_new" :value="1">新品</Checkbox>
                <Checkbox v-model="formData.is_hot" :value="1">热销</Checkbox>
              </FormItem>

              <FormItem label="销售" prop="is_on_sale">
                <RadioGroup v-model="formData.is_on_sale">
                  <Radio :label="1">销售中</Radio>
                  <Radio :label="0">停止销售</Radio>
                </RadioGroup>
              </FormItem>

              <Row>
                <Col span="8">
                  <FormItem label="官方售价" prop="shop_price">
                    <InputNumber :min="0" style="width:100%" v-model="formData.shop_price"></InputNumber>
                  </FormItem>
                </Col>
                <Col span="8">
                  <FormItem label="虚拟销量" prop="virtual_sales">
                    <InputNumber :min="0" style="width:100%" v-model="formData.virtual_sales"></InputNumber>
                  </FormItem>
                </Col>
                <Col span="8">
                  <FormItem label="销售单位" prop="quantityunit">
                    <Select v-model="formData.quantityunit">
                      <Option
                        :value="item.value"
                        :label="item.value"
                        v-for="(item, index) in quantityUnitList"
                        :key="index"
                      ></Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <FormItem label="服务">
                <Select v-model="formData.serviceid">
                  <Option :value="0" label="无"></Option>
                  <Option
                    :value="item.id"
                    :label="item.name"
                    v-for="(item, index) in serviceList"
                    :key="index"
                  ></Option>
                </Select>
              </FormItem>
              <FormItem label="标签">
                <Tag
                  color="primary"
                  v-for="(item, index) in tagsList"
                  :key="index"
                  :name="item"
                  closable
                  @on-close="handleCloseTag"
                >{{ item }}</Tag>
              </FormItem>
              <FormItem label="标签">
                <Row>
                  <Col span="8">
                    <Input v-model="inputTag" />
                  </Col>
                  <Col span="4">
                    <button type="button" class="btn btn-theme" @click="fn_add_tag">增加标签</button>
                  </Col>
                </Row>
              </FormItem>
              <Row>
                <Col span="8">
                  <FormItem label="排序">
                    <InputNumber style="width:100%" v-model="formData.sortval"></InputNumber>
                  </FormItem>
                </Col>
              </Row>
            </Col>
          </Row>
        </TabPane>
        <TabPane icon="md-search" label="详细描述">
          <div class="editor-wrapper">
            <div :id="editorId"></div>
          </div>
        </TabPane>

        <TabPane icon="md-menu" label="价格参数">
          <Card :title="'价格参数:' + priceTitle">
            <div slot="extra">
              <button
                v-if="priceTitle.length > 0"
                class="btn btn-theme btn-sm"
                type="button"
                @click="fn_add_priceattr()"
              >
                <i class="fa fa-plus"></i> 新增
              </button>
            </div>
            <Row>
              <Col span="4">
                <Menu @on-select="fn_open_priceattr" style="width:100%" :active-name="active_menu">
                  <MenuItem
                    :name="index"
                    v-for="(item, index) in priceAttrList"
                    :key="index"
                  >{{ item.name }}</MenuItem>
                </Menu>
              </Col>
              <Col span="20">
                <table class="table table-bordered m-l-10 m-r-10">
                  <thead>
                    <th>名称</th>
                    <th>Logo</th>
                    <th>排序</th>
                    <th>操作</th>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in priceAttrListData" :key="index">
                      <td>{{ row.name }}</td>
                      <td>
                        <img
                          v-if="row.logo && row.logo.length > 0"
                          :src="logourl + row.logo"
                          style="max-height:100px"
                        />
                      </td>
                      <td>{{ row.sortval }}</td>
                      <td>
                        <button
                          class="btn btn-theme btn-sm"
                          type="button"
                          @click="fn_edit_priceattr(row)"
                        >
                          <i class="fa fa-edit"></i> 修改
                        </button>
                        <Poptip
                          class="m-l-3"
                          transfer
                          confirm
                          title="确认要删除这商品价格参数?"
                          @on-ok="fn_remove_priceattr(row, index)"
                          ok-text="确认"
                          cancel-text="取消"
                        >
                          <button class="btn btn-danger btn-sm" type="button" ghost>
                            <i class="fa fa-times"></i> 删除
                          </button>
                        </Poptip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </Card>
        </TabPane>
        <TabPane icon="md-menu" label="商品图集">
          <div class="row">
            <div class="col-md-3" v-for="(item, index) in galleryList" :key="index">
              <!-- begin card -->
              <div class="card">
                <Poptip
                  confirm
                  class="pull-right"
                  title="要删除此图片吗?"
                  @on-ok="fn_remove_gallery(item, index)"
                >
                  <button class="btn btn-danger btn-xs" type="button">
                    <i class="fa fa-times"></i>
                  </button>
                </Poptip>
                <img class="card-img-top" :src="logourl + item.img_url" />
              </div>
              <!-- end card -->
            </div>

            <!-- end col-6 -->
          </div>
          <div class="row">
            <div class="col-md-12">
              <Upload
                multiple
                type="drag"
                name="filename"
                ref="refupload"
                :action="uploadhost"
                :format="['jpg', 'jpeg', 'png']"
                :on-success="fn_uploadGallerySuccess"
                :max-size="2048"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
              >
                <div style="padding: 15px 0">
                  <Icon type="ios-cloud-upload" size="56" style="color: #3399ff"></Icon>
                  <p>把文件拖动到框内上传</p>
                  <p>Click or drag files here to upload</p>
                </div>
              </Upload>
            </div>
          </div>
        </TabPane>
        <TabPane icon="md-menu" label="商品参数">
          <table class="table table-bordered">
            <thead>
              <th width="10%">参数名称</th>
              <th>参数值</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in typeAttrList" :key="index">
                <td>{{ item.attr_name }}</td>
                <td style="padding:0px 0px 0px 3px">
                  <fieldControl :typeAttr="item"></fieldControl>
                </td>
              </tr>
            </tbody>
          </table>
        </TabPane>
        <TabPane v-if="formData.id > 0" icon="md-menu" label="兑换卡">
          <Row>
            <Col span="12">
              <Row :gutter="5">
                <Col span="8">
                  <Input type="text" v-model="card_fileCond.cardnumber" placeholder="请输入查询卡号" />
                </Col>
                <Col span="4">
                  <Button class="btn btn-theme" @click="fn_search_card">查询</Button>
                </Col>
              </Row>
              <Table class="m-t-10" :columns="cardColumns" :data="cardDataList">
                <template slot-scope="{row}" slot="status">
                  <span v-if="row.status ==0">未使用</span>
                  <span v-else-if="row.status ==1" style="color:green">已使用</span>
                  <span v-else-if="row.status == -1" style="color:red">作废</span>
                </template>
                <template slot-scope="{row}" slot="action">
                  <Poptip
                    v-if="row.status == 0"
                    transfer
                    confirm
                    title="确认要作废此卡,必须上传文件人员才允许作废?"
                    @on-ok="fn_cancel_card(row)"
                    ok-text="确认"
                    cancel-text="取消"
                  >
                    <button class="btn btn-danger btn-sm" type="button" ghost>
                      <i class="fa fa-times"></i> 作废
                    </button>
                  </Poptip>
                </template>
              </Table>
              <Page
                style="margin-top:10px"
                :total="card_totalRows"
                :current="card_fileCond.page"
                :page-size="card_fileCond.pageNum"
                show-total
                show-elevator
                @on-change="fn_card_swithPage"
              />
            </Col>
            <Col span="12">
              <Form :model="FormUpload" :labelWidth="120">
                <FormItem label="上传模板">
                  请根据上传模板进行兑换卡的上传,每次上传兑换卡数量不超过1000,如果超过1000,请分多次上传,
                  <a
                    :href="logourl + '/template/exchangecard.xlsx'"
                  >模板文件</a>
                </FormItem>
                <FormItem label="文件">
                  <Upload
                    name="filename"
                    :show-upload-list="true"
                    :action="uploadhost"
                    :format="['xlsx']"
                    :on-success="fn_cardUploadSuccess"
                    :max-size="2048"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    style="display: inline-block;"
                  >
                    <Button icon="ios-cloud-upload-outline">上传兑换卡</Button>
                  </Upload>
                </FormItem>
                <FormItem label="备注">
                  <Input type="text" :rows="3" v-model="FormUpload.remarks" />
                </FormItem>
                <FormItem label>
                  <Button class="btn btn-theme" @click="btn_save_upload">保存</Button>
                </FormItem>
                <FormItem label>
                  <Table :columns="exchangeCardColumn" :data="ExchangeCardFileList">
                    <template slot="action" slot-scope="{row}">
                      <button
                        v-if="row.status == 0"
                        type="button"
                        class="btn btn-theme btn-sm m-r-5"
                        @click="fn_pro_exchange_card_file(row)"
                      >处理</button>

                      <Poptip
                        transfer
                        v-if="row.status !== -1"
                        confirm
                        title="确认要作废此兑换卡文件,必须上传文件人员才允许作废,只作废未兑换使用的卡?"
                        @on-ok="fn_cancel_cardfile(row)"
                        ok-text="确认"
                        cancel-text="取消"
                      >
                        <button class="btn btn-danger btn-sm" type="button" ghost>
                          <i class="fa fa-times"></i> 作废
                        </button>
                      </Poptip>
                    </template>
                  </Table>
                  <Page
                    style="margin-top:10px"
                    :total="cardfile_totalRows"
                    :current="cardfile_filterCond.currentPage"
                    :page-size="cardfile_filterCond.pageNum"
                    show-total
                    show-elevator
                    @on-change="fn_cardfile_switchPage"
                  />
                </FormItem>
              </Form>
            </Col>
          </Row>
        </TabPane>
      </Tabs>
    </Form>
    <div class="demo-drawer-footer">
      <!-- <button
        type="button"
        class="btn btn-default"
        style="margin-right: 8px"
        @click="v_edit_goods = false"
      >关闭</button>-->
      <button type="button" class="btn btn-theme" @click="fn_store_data">保存</button>
    </div>

    <Modal v-model="v_edit_priceattr" :z-index="10240" draggable scrollable title="商品的价格属性参数">
      <Form
        :model="priceAttrFormData"
        ref="priceAttrFormData"
        :rules="priceAttrFormDataRules"
        :labelWidth="120"
      >
        <FormItem label="参数名称" label-position="top" prop="name">
          <Input v-model="priceAttrFormData.name" placeholder="参数名称" />
        </FormItem>
        <FormItem label="商品图片">
          <Upload
            name="filename"
            :show-upload-list="false"
            :action="uploadhost"
            :format="['jpg', 'jpeg', 'png']"
            :on-success="fn_priceAttr_uploadSuccess"
            :max-size="2048"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            style="display: inline-block;width:90px;"
          >
            <Button icon="ios-cloud-upload-outline">上传图片</Button>
          </Upload>
        </FormItem>
        <FormItem label="排序" label-position="top">
          <InputNumber v-model="priceAttrFormData.sortval"></InputNumber>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <button
          type="button"
          class="btn btn-default"
          style="margin-right: 8px"
          @click="v_edit_priceattr = false"
        >关闭</button>
        <button type="button" class="btn btn-theme" @click="fn_confirm_addpriceattr">确认</button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect'
import Cropper from '@/components/cropper/index.vue'
import fieldControl from './fieldControl'
import Editor from 'wangeditor'
import 'wangeditor/release/wangEditor.css'
import { getToken } from '@/libs/util'
import config from '@/config'
import { uploadbase64 } from '@/api/upload'

import {
  getGoodsTypePriceAttrList,
  getTypeAttributeList,
  storeGoodsData,
  removeGoodsTypePriceAttrData,
  removeGalleryById,
  saveExchangeCardUploadFile,
  loadExchangeCardFileList,
  storeExchangeCardFormFile,
  loadExchangeCardList,
  cancelExchangeCard,
  cancelExchangeCardFile,
} from '@/api/goods'
export default {
  components: { Treeselect, Cropper, Editor, fieldControl },
  data() {
    return {
      active_menu: 0,
      uploadhost: config.baseUrl.pro + '/upload/uploadfile',
      logourl: config.baseUrl.imageurl,
      formData: {
        id: 0,
        goods_name: '',
        goods_sn: '',
        typeid: 0,
        categoryid: 0,
        brandid: 0,
        keywords: '',
        goods_brief: '',
        remarks: '',
        is_best: 0,
        is_hot: 0,
        is_new: 1,
        is_on_sale: 0,
        sortval: 0,
        original_img: '',
        goods_thumb: '',
        virtual_sales: 0,
        shop_price: 0,
        quantityunit: '',
        orderquantity: 0,
      },
      attrValueList: {},
      tagsList: [],
      inputTag: '',
      rules: {
        goods_name: [
          {
            required: true,
            message: '商品名称必填',
            trigger: 'blur',
          },
        ],
        typeid: [
          {
            type: 'number',
            min: 0.1,
            required: true,
            message: '商品类别必填',
            trigger: 'blur',
          },
        ],
        goods_brief: [
          {
            required: true,
            message: '商品描述必填',
            trigger: 'blur',
          },
        ],
        quantityunit: [
          {
            required: true,
            message: '单位不能为空',
            trigger: 'change',
          },
        ],
      },
      goodsImageSrc: '',

      typeAttrList: [],
      priceAttrList: [],

      priceAttrFormData: {
        id: 0,
        goodsid: 0,
        typeid: 0,
        attrid: 0,
        attr_name: '',
        name: '',
        logo: '',
        sortval: 0,
      },
      priceAttrFormDataRules: {
        name: [
          {
            required: true,
            message: '参数名称必填',
            trigger: 'blur',
          },
        ],
      },
      v_edit_priceattr: false,
      v_edit_priceattr_add: false,
      editPriceAttr: {},
      priceAttrListData: [],
      priceTitle: '',
      editor: null,
      galleryList: [],
      FormUpload: {
        id: 0,
        goods_id: 0,
        type: 'exchange_card',
        filename: '',
        remarks: '',
      },
      ExchangeCardFileList: [],
      exchangeCardColumn: [
        {
          title: '#ID',
          key: 'id',
          width: 50,
        },
        {
          title: '文件名称',
          key: 'filename',
          width: 250,
        },
        {
          title: '备注',
          key: 'remarks',
        },
        {
          title: '操作',
          slot: 'action',
          width: 130,
        },
      ],
      cardfile_totalRows: 0,
      cardfile_filterCond: {
        goods_id: 0,
        currentPage: 1,
        pageNum: 8,
      },
      //卡的列头
      cardColumns: [
        {
          title: '卡号',
          key: 'cardnumber',
          width: 200,
        },
        {
          title: '使用状态',
          slot: 'status',
          width: 100,
        },
        {
          title: '兑换时间',
          key: 'exchangetime',
        },
        {
          title: '操作',
          slot: 'action',
          width: 100,
        },
      ],
      cardDataList: [],
      card_fileCond: {
        page: 1,
        pageNum: 15,
        goods_id: 0,
        cardnumber: '',
      },
      card_totalRows: 0,
    }
  },
  computed: {
    editorId() {
      return `editor${this._uid}`
    },
  },
  watch: {
    goodsdata: {
      handler: function (val, old) {
        // console.log("watch", val);
        console.log(this.action)
        if (this.action == 'new') {
          this.formData = {
            id: 0,
            goods_name: '',
            goods_sn: '',
            typeid: this.typeList[0].id,
            categoryid: 0,
            brandid: 0,
            keywords: '',
            goods_brief: '',
            remarks: '',
            is_best: 0,
            is_hot: 0,
            is_new: 1,
            is_on_sale: 0,
            sortval: 0,
            original_img: '',
            goods_thumb: '',
            virtual_sales: 0,
            shop_price: 0,
            quantityunit: '',
            orderquantity: 0,
          }
          this.tagsList = []
          this.typeAttrList = []
          this.priceAttrList = []
          this.priceAttrListData = []

          this.galleryList = []
          this.editor.txt.html('')
        } else {
          this.formData = val
          this.editor.txt.html(this.formData.goods_desc)

          this.galleryList = val.goods_gallery

          this.goodsImageSrc = val.goods_thumb
          this.tagsList = val.tags
        }
        this.fn_load_typeattrlsit(this.formData.typeid)

        this.active_menu = 0

        this.FormUpload.goods_id = val.id
        this.cardfile_filterCond.goods_id = this.formData.id
        this.fn_load_exchange_filelist(this.cardfile_filterCond)

        //卡数据查询
        this.card_fileCond.goods_id = this.formData.id

        this.fn_load_exchangecard()
        // console.log(this.formData.goods_desc);

        // console.log(this.tags);
        // console.log(this.active_menu);
      },
    },
    action: {
      handler: function (val, old) {
        if (val == 'new') {
          this.formData = {
            id: 0,
            goods_name: '',
            goods_sn: '',
            typeid: this.typeList[0].id,
            categoryid: 0,
            brandid: 0,
            keywords: '',
            goods_brief: '',
            remarks: '',
            is_best: 0,
            is_hot: 0,
            is_new: 1,
            is_on_sale: 0,
            sortval: 0,
            original_img: '',
            goods_thumb: '',
            virtual_sales: 0,
            shop_price: 0,
            quantityunit: '',
            orderquantity: 0,
          }
          this.tagsList = []
          this.typeAttrList = []
          this.priceAttrList = []
          this.priceAttrListData = []
          this.fn_load_typeattrlsit(this.typeList[0].id)
          this.galleryList = []
          this.editor.txt.html('')
        }
      },
    },
  },
  mounted() {
    this.iniRichText()
  },
  methods: {
    fn_cancel_cardfile(row) {
      //作废一个文件以及所有未兑换的卡
      cancelExchangeCardFile(row.id)
        .then((res) => {
          if (res.data.code === 200) {
            row.status = -1
            this.$Notice.success(res.data)
          } else {
            this.$Notice.error(res.data)
          }
        })
        .catch((error) => {
          this.$Message.error(error)
        })
    },
    fn_card_swithPage(page) {
      this.card_fileCond.page = page
      this.fn_load_exchangecard()
    },
    fn_cancel_card(row) {
      //作废一张卡
      cancelExchangeCard(row.id)
        .then((res) => {
          if (res.data.code === 200) {
            row.status = -1
            this.$Notice.success(res.data)
          } else {
            this.$Notice.error(res.data)
          }
        })
        .catch((error) => {
          this.$Message.error(error)
        })
    },
    fn_search_card() {
      this.card_fileCond.page = 1
      this.fn_load_exchangecard()
    },
    fn_load_exchangecard() {
      loadExchangeCardList(this.card_fileCond)
        .then((res) => {
          this.card_totalRows = res.data.total
          this.cardDataList = res.data.data
        })
        .catch((error) => {
          this.$Message.error(error)
        })
    },

    btn_save_upload() {
      //兑换卡文件按上传
      saveExchangeCardUploadFile(this.FormUpload)
        .then((res) => {
          if (res.data.code == 200) {
            this.ExchangeCardFileList.unshift(res.data.data)
          }
        })
        .catch((error) => {
          this.$Message.error(error)
        })
    },
    fn_cardfile_switchPage(page) {
      //兑换卡文件下一页
      this.cardfile_filterCond.currentPage = page
      this.fn_load_exchange_filelist(this.cardfile_filterCond)
    },
    fn_load_exchange_filelist(filterCond) {
      //装载兑换卡文件
      loadExchangeCardFileList(filterCond)
        .then((res) => {
          this.cardfile_totalRows = res.data.total
          this.ExchangeCardFileList = res.data.data
        })
        .catch((error) => {
          this.$Message.error(error)
        })
    },
    fn_pro_exchange_card_file(row) {
      storeExchangeCardFormFile(row.id)
        .then((res) => {
          if (res.data.code == 200) {
            row.status = 1
            this.$Notice.success(res.data)
          } else {
            this.$Notice.error(res.data)
          }
        })
        .catch((error) => {
          this.$Message.error(error)
        })
    },

    handleCloseTag(event, name) {
      const index = this.tagsList.indexOf(name)
      this.tagsList.splice(index, 1)
    },
    fn_add_tag() {
      this.tagsList.push(this.inputTag)
      this.inputTag = ''
    },
    fn_open_priceattr(index) {
      this.priceAttrListData = this.priceAttrList[index].children
      this.editPriceAttr = this.priceAttrList[index]
      this.priceTitle = this.priceAttrList[index].name
    },
    //确认增加价格属性参数
    fn_confirm_addpriceattr() {
      if (this.v_edit_priceattr_add)
        this.editPriceAttr.children.push(this.priceAttrFormData)

      this.v_edit_priceattr = false
    },
    fn_add_priceattr() {
      this.v_edit_priceattr = true
      this.v_edit_priceattr_add = true

      this.priceAttrFormData = {
        id: 0,
        goodsid: this.formData.id,
        typeid: this.editPriceAttr.typeid,
        attrid: this.editPriceAttr.id,
        attr_name: this.editPriceAttr.name,
        name: '',
        logo: '',
        sortval: 0,
      }
    },
    fn_edit_priceattr(row) {
      console.log(row)
      this.v_edit_priceattr = true
      this.v_edit_priceattr_add = false
      this.priceAttrFormData = row
    },
    fn_remove_priceattr(row, index) {
      if (row.id > 0) {
        removeGoodsTypePriceAttrData(row.id).then((res) => {
          if (res.data.code == 200) {
            this.priceAttrListData.splice(index, 1)
          }
        })
      } else {
        this.priceAttrList.splice(index, 1)
      }
    },
    //获取商品的的价格属性和属性值
    fn_load_priceAttrList(goodsid, typeid) {
      getGoodsTypePriceAttrList(goodsid, typeid)
        .then((res) => {
          this.priceAttrList = res.data
          //   console.log(this.priceAttrList);
          if (this.priceAttrList.length > 0) this.fn_open_priceattr(0)
        })
        .catch((error) => {
          this.$Message.error(error)
        })
    },
    fn_load_typeattrlsit(typeid) {
      //获取商品参数定义

      getTypeAttributeList({
        typeid: typeid,
        pageNum: 0,
        page: 0,
      })
        .then((res) => {
          this.typeAttrList = res.data
          if (this.formData.id > 0) {
            let typeAttrListValue = JSON.parse(this.formData.attrs)
            for (let index = 0; index < this.typeAttrList.length; index++) {
              this.typeAttrList[index].value =
                typeAttrListValue[this.typeAttrList[index].id]
            }
          }
        })
        .catch((error) => {
          this.$Message.error('参数: ' + error)
        })
      this.fn_load_priceAttrList(this.formData.id, typeid)
    },
    fn_store_data() {
      //商品图片是否上传
      if (this.formData.original_img.length == 0) {
        this.$Message.error('商品图片还未上传')
        return
      }
      if (this.formData.goods_thumb.length == 0) {
        this.$Message.error('商品缩略图还未上传')
        return
      }
      //------begin 自定义参数开始
      this.attrValueList = {}
      for (let index = 0; index < this.typeAttrList.length; index++) {
        const element = this.typeAttrList[index]
        this.attrValueList[element.id] = element.value
      }
      this.formData.attrs = JSON.stringify(this.attrValueList)
      //------自定义参数结束

      //------begin 价格参数
      //   console.log(this.priceAttrList);
      let priceParamsData = []
      for (let index = 0; index < this.priceAttrList.length; index++) {
        const element = this.priceAttrList[index]
        priceParamsData = priceParamsData.concat(element.children)
      }
      //------end   价格参数
      //   console.log("begin validate");
      if (this.formData.goods_desc == null) this.formData.goods_desc = ''

      //标签
      this.formData.tags = JSON.stringify(this.tagsList)

      this.$refs.goodsFormData.validate((valid) => {
        if (valid) {
          storeGoodsData(this.formData, priceParamsData, this.galleryList)
            .then((res) => {
              if (res.data.code == 200) {
                this.$Notice.success(res.data)
                if (this.formData.id == 0) {
                  this.$emit('on_new_refresh', res.data.data)
                }
              } else {
                this.$Notice.error(res.data)
              }
            })
            .catch((error) => {
              this.$Message.error(error)
            })
        }
      })
    },
    fn_uploadSuccess(res, file) {
      if (file.response.code === 200) {
        this.formData.original_img = file.response.data
      }
    },
    fn_simpleUploadSuccess(res, file) {
      if (file.response.code === 200) {
        this.formData.goods_thumb = file.response.data
      }
    },
    fn_cardUploadSuccess(res, file) {
      if (file.response.code === 200) {
        this.FormUpload.filename = file.response.data
      }
    },
    fn_priceAttr_uploadSuccess(res, file) {
      if (file.response.code === 200) {
        this.priceAttrFormData.logo = file.response.data
      }
    },
    fn_uploadGallerySuccess(res, file) {
      //商品图片集合
      if (file.response.code === 200) {
        this.galleryList.push({
          id: 0,
          goodsid: this.formData.id,
          img_url: file.response.data,
        })
      }
    },
    fn_remove_gallery(item, index) {
      //删除图片
      if (item.id == 0) {
        this.galleryList.splice(index, 1)
      } else {
        removeGalleryById(item.id)
          .then((res) => {
            if (res.data.code == 200) {
              this.galleryList.splice(index, 1)
            } else {
              this.$Notice.error(res.data)
            }
          })
          .catch((error) => {
            this.$Message.error(error)
          })
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc:
          '文件 ' + file.name + ' 格式不正确，请上传 jpg 或 png 格式的图片。',
      })
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '超出文件大小限制',
        desc: '文件 ' + file.name + ' 太大，不能超过 2M。',
      })
    },
    handleCroped(blob) {
      const formData = new FormData()
      formData.append('filename', blob)
      uploadbase64(formData)
        .then((res) => {
          if (res.data.code == 200) {
            this.formData.goods_thumb = res.data.data
          }
        })
        .catch((error) => {
          this.$Message.error(error)
        })
      //   uploadImg(formData).then(() => {
      //     this.$Message.success("Upload success~");
      //   });
    },

    iniRichText() {
      // console.log(this.Field.columname, this.FieldListData);
      this.editor = new Editor(`#${this.editorId}`)
      this.editor.customConfig.onchange = (html) => {
        let text = this.editor.txt.text()
        if (this.cache) localStorage.editorCache = html
        this.$emit('input', this.valueType === 'html' ? html : text)
        this.$emit('on-change', html, text)
      }
      this.editor.customConfig.onchangeTimeout = this.changeInterval
      // create这个方法一定要在所有配置项之后调用
      this.editor.customConfig.zIndex = 1 // 设置菜单的垂直高度

      this.editor.customConfig.uploadImgServer = this.uploadhost
      //  "http://47.106.198.122/api/CanteenAdmin/CanteenManagement/UploadImage"; // 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = {
        Authorization: 'Bearer' + getToken(),
      } // 自定义 header
      this.editor.customConfig.uploadFileName = 'filename' // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024 // 将图片大小限制为 2M
      this.editor.customConfig.uploadImgMaxLength = 6 // 限制一次最多上传 3 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000 // 设置超时时间
      // this.editor.customConfig.uploadParams = {formFile:'2'};
      // 配置菜单
      this.editor.customConfig.menus = [
        'head',
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'image', // 插入图片
        'table', // 表格
        'video', // 插入视频
        'code', // 插入代码
        'undo', // 撤销
        'redo', // 重复
      ]

      this.editor.customConfig.uploadImgHooks = {
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
          //
          let imgUrl = result.data
          insertImg(imgUrl)
        },
        timeout: (xhr, editor) => {
          // 网络超时的回调
        },
        error: (xhr, editor) => {
          console.log(editor)
          // 图片上传错误的回调
        },
        customInsert: (insertImg, result, editor) => {
          // 图片上传成功,插入图片的回调

          // if(result.code == 200){
          var url = this.logourl + result.data
          //   console.log(url);
          insertImg(url) //将内容插入到富文本中
          // console.log(insertImg(url)+"DFDF")
          // console.log(data+"dsfd")
          // }
        },
      }

      this.editor.customConfig.onchange = (html) => {
        this.info_ = html // 绑定当前逐渐地值
        this.$emit('change', this.info_) // 将内容同步到父组件中
        this.formData.goods_desc = html
      }

      // 创建富文本编辑器

      this.editor.create()
      // 如果本地有存储加载本地存储内容
    },
  },
  props: [
    'action',
    'goodsdata',
    'brandList',
    'categoryTree',
    'typeList',
    'serviceList',
    'quantityUnitList',
  ],
}
</script>
